import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">

          {/* Brand */}
          <div className="footer-section">
            <h3 className="footer-logo">
              <span className="logo-icon">🌾</span>
              GANGASEED®
            </h3>
            <p className="footer-tagline">THE FARMER'S NEED</p>
            <p className="footer-description">
              Gangaseed Company — AN ISO 9001:2015 &amp; ISO 22000:2018
              Certified Seed Company dedicated to empowering farmers with
              high-quality, reliable seeds.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div className="footer-section">
            <h4>Our Products</h4>
            <ul>
              <li><Link to="/products">Vegetable Seeds</Link></li>
              <li><Link to="/products">Hybrid Seeds</Link></li>
              <li><Link to="/products">Field Crops</Link></li>
              <li><Link to="/products">View All Products</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Contact Info</h4>
            <ul className="contact-info">
              <li>
                📍 Plot No. 619, Nr Vihar Cross Road,
                Mahesana-Himatnagar Highway, Vihar,
                Dist.- Gandhinagar – 382810 (Gujarat) India
              </li>
              <li>
                📞 <a href="tel:+919909998802">+91 9909998802</a>
              </li>
              <li>
                ✉️ <a href="mailto:care.devkor@gmail.com">care.devkor@gmail.com</a>
              </li>
              <li>
                🌐 <a href="https://www.devkorseed.com" target="_blank" rel="noopener noreferrer">
                  www.devkorseed.com
                </a>
              </li>
            </ul>
          </div>

        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Gangaseed Company. All rights reserved.</p>
          <p className="footer-cert">
            AN ISO 9001:2015 &amp; ISO 22000:2018 Certified Seed Company
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
